import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'noSafeUrl',
  standalone: false,
})
export class NoSafeUrlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  public transform(value: any, prefix = '') {
    return this.domSanitizer.bypassSecurityTrustUrl(prefix + value);
  }
}
